<template>
  <div>
    <v-dialog persistent v-model="specialDialog" width="450">
      <v-card rounded="xl">
        <v-card-title
          >Özel Sayı
          <v-spacer />
          <v-btn icon @click="specialCancel()">
            <v-icon>
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="nightDarkTon px-9 py-12">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="specialDialogNumber"
                filled
                placeholder="Kişi Sayısını Girin"
                persistent-placeholder
                rounded
                hide-details=""
                suffix="Kişilik"
              />
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12" md="8">
              <v-btn
                rounded
                block
                x-large
                color="secondary"
                @click="specialSubmit"
                >Gönder</v-btn
              >
            </v-col>
            <v-col cols="12" md="4">
              <v-btn rounded block plain @click="specialCancel()">Vazgeç</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="false">
      <v-card-title class="">
        <div class="mr-6 primary--text font-weight-bold text-subtitle-1">
          Pasta Tipi
        </div>
        <v-divider></v-divider>
      </v-card-title>
      <v-item-group v-model="data.cakeType" mandatory>
        <v-row class="pb-3">
          <v-col
            v-for="(item, index) in cakeStore.cakeTypes"
            :key="index"
            cols="12"
            md="6"
          >
            <v-item :value="item.value" v-slot="{ active, toggle }">
              <v-card
                :color="active ? 'secondary' : 'chip'"
                class="d-flex align-center overflow-hidden"
                height="300"
                rounded="xl"
                flat
                @click="toggle"
              >
                <div class="px-6">
                  <h5
                    class="text-h4 font-weight-bold pt-16 pb-3"
                    :style="active ? 'color:white !important' : null"
                  >
                    {{ item.text }}
                  </h5>
                  <div class="mb-9 text-body-1">{{ item.explanation }}</div>
                  <v-chip
                    :color="active ? 'chip' : 'grey'"
                    style="font-size: 11px !important"
                    >Kişi başı : {{ item.price | currency }}</v-chip
                  >
                </div>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
    </div>
    <v-card-title class="mt-9">
      <div class="mr-6 primary--text font-weight-bold text-subtitle-1">
        Kişi Sayısı
      </div>
      <v-divider></v-divider>
    </v-card-title>
    <v-item-group v-model="data.numberOfPeople" :mandatory="!isSpecial">
      <v-row>
        <v-col
          v-for="(item, index) in cakeStore.numberOfPeoples"
          :key="index"
          cols="12"
          md="4"
        >
          <v-item :value="item" v-slot="{ active, toggle }">
            <v-card
              :color="active ? 'secondary' : 'chip'"
              class="d-flex align-center overflow-hidden"
              rounded="xl"
              flat
              height="150"
              @click="toggle"
            >
              <div class="px-6">
                <div
                  class="text-h5 mt-3 font-weight-bold"
                  :style="active ? 'color:white !important' : null"
                >
                  {{ item }} Kişilik
                </div>
                <v-chip
                  class="mt-2 text-overline"
                  style="font-size: 11px !important"
                  :color="active ? 'chip' : null"
                  >{{
                    (cakeStore.cakeTypes[data.cakeType].price * item) | currency
                  }}</v-chip
                >
              </div>
            </v-card>
          </v-item>
        </v-col>
        <v-col>
          <v-card
            :color="isSpecial ? 'secondary' : 'chip'"
            class="d-flex align-center overflow-hidden"
            rounded="xl"
            flat
            height="150"
            @click="specialClick"
          >
            <div class="px-6">
              <div class="text-h5 font-weight-bold">Özel Sayı</div>
              <div v-if="data.specialNumber > 0">
                {{ data.specialNumber }} Kişilik
              </div>
              <v-chip
                v-if="data.specialNumber > 0"
                class="mt-2 text-overline"
                style="font-size: 11px !important"
                color="chip"
              >
                {{
                  (cakeStore.cakeTypes[data.cakeType].price *
                    data.specialNumber)
                    | currency
                }}
              </v-chip>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-item-group>

    <v-row align="center" class="my-9">
      <v-col cols="12" md="6"> </v-col>
      <v-col cols="12" md="6">
        <v-btn
          color="secondary"
          class="text-capitalize"
          depressed
          rounded
          x-large
          block
          @click="continueStep()"
        >
          Devam Et
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useRouter } from "@core/utils";
import { useCakeStore } from "@/stores/cake";

import { watch, onMounted, ref, nextTick } from "@vue/composition-api";
import { mdiAccountMultiple, mdiCakeLayered, mdiClose } from "@mdi/js";
export default {
  setup() {
    const { route } = useRouter();
    const cakeStore = useCakeStore();

    cakeStore.cakeOrderParams();

    const data = ref({
      numberOfPeople: 0,
      cakeType: 0,
      specialNumber: 0,
    });

    onMounted(async () => {
      if (route.value.params.item) {
        data.value = cakeStore.data.cake;
      }
      // await getPosts();
    });

    const isSpecial = ref(false);
    const specialDialogNumber = ref(null);
    const specialDialog = ref(false);
    const specialClick = () => {
      isSpecial.value = true;
      specialDialog.value = true;
      data.value.numberOfPeople = null;
    };

    watch(
      () => data.value.numberOfPeople,
      (val) => {
        if (typeof val !== "object") {
          isSpecial.value = false;
          data.value.specialNumber = 0;
        }
      }
    );
    const specialSubmit = () => {
      data.value.specialNumber = specialDialogNumber.value;
      specialDialog.value = false;
    };

    const specialCancel = () => {
      data.value.numberOfPeople = 0;
      isSpecial.value = false;
      data.value.specialNumber = 0;
      specialDialog.value = false;
    };

    const continueStep = async () => {
      cakeStore.data.cake = data;
      cakeStore.increment();
    };

    return {
      data,
      continueStep,
      specialClick,
      isSpecial,
      specialDialog,
      cakeStore,
      specialDialogNumber,
      specialSubmit,
      specialCancel,
      icons: {
        mdiAccountMultiple,
        mdiCakeLayered,
        mdiClose,
      },
    };
  },
};
</script>

<style></style>
